import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { ServicesComponent } from './services/services.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { WhyComponent } from './why/why.component';
import { DevelopersComponent } from './developers/developers.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { RentPropertiesComponent } from './rent-properties/rent-properties.component';
import { BuyPropertiesComponent } from './buy-properties/buy-properties.component';
import { PropertyDetailComponent } from './property-detail/property-detail.component';
import { BlogsComponent } from './blogs/blogs.component';
import { BlogDetailsComponent } from './blog-details/blog-details.component';
import { CampaignComponent } from './campaign/campaign.component';

const routes: Routes = [
  {
    path:'',
    component:HomeComponent
  },
  {
    path:'about',
    component:AboutComponent
  },
  {
    path:'contact',
    component:ContactComponent
  },
  {
    path:'services',
    component:ServicesComponent
  },
  {
    path:'privacy',
    component:PrivacyComponent
  },
  {
    path:'why',
    component:WhyComponent
  },
  {
    path:'developers',
    component:DevelopersComponent
  },
  {
    path:'terms-condition',
    component:TermsConditionComponent
  },
  {
    path:'rent-properties',
    component:RentPropertiesComponent
  },
  {
    path:'buy-properties',
    component:BuyPropertiesComponent
  },
  {
    path:'propertydetail/:id',
    component:PropertyDetailComponent
  },
  {
    path:'guides',
    component:BlogsComponent
  },
  {
    path:'guide/:id',
    component:BlogDetailsComponent
  },
  {
    path:'campaign/:id',
    component:CampaignComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
